import queryStringify from 'querystringify';

import { parseFullName } from './parse-full-name';
import { BusinessInfo, IFormSubmitValues } from '../types';

export const getFormSubmitValues = (formState: BusinessInfo): IFormSubmitValues => {
  const {
    businessName,
    city,
    country,
    email,
    fullName,
    grouponSubscription,
    phone,
    physicalLocations,
    state,
    streetAddress,
    typeOfBusiness,
    categoryPds,
    website,
    zipCode,
  } = formState;

  const queryParams: { utm_campaign?: string } = queryStringify.parse(decodeURI(location.search));
  const utmCampaign = queryParams.utm_campaign
    ? queryParams.utm_campaign
    : !!document.referrer
    ? 'Other'
    : 'Direct';

  const { firstName, lastName } = parseFullName(fullName);

  return {
    businessName,
    postal_code: zipCode,
    street: streetAddress,
    city,
    country,
    state,
    physicalLocations,
    email,
    website,
    news_updates: grouponSubscription,
    lead_source: 'Web to Lead',
    utm_medium: 'organic',
    utm_source: 'merchant',
    typeOfBusiness,
    categoryPds,
    web_to_lead_channel: 'Local',
    campaign_name: '(organic)',
    phone,
    firstName,
    lastName,
    utmCampaign,
  };
};
